module.exports = __webpack_public_path__ + "static/media/Pitech-logoconv.9ede767f.png";